import { useEffect } from "react";
import { LangProvider } from "../../i18n/LangContext";
import { SmoothScroll } from "./SmoothScroll";
import { Header } from "./Header";
import { Footer } from "./Footer";
import { MobileBar } from "./MobileBar";

const ScrollOnEnter = () => {
  useEffect(() => {
    const { hash } = window.location;
    if (!hash) {
      window.scrollTo(0, 0);
      return undefined;
    }
    const t = setTimeout(() => document.querySelector(hash)?.scrollIntoView(), 300);
    return () => clearTimeout(t);
  }, []);
  return null;
};

export const Shell = ({ lang, slug = "", meta, children }) => (
  <LangProvider dict={lang.dict} legal={lang.legal} slug={slug} meta={meta}>
    <div className="site min-h-screen overflow-x-clip bg-white text-black">
      <SmoothScroll />
      <ScrollOnEnter />
      <Header />
      <main>{children}</main>
      <Footer />
      <MobileBar />
    </div>
  </LangProvider>
);
